module.exports = __webpack_public_path__ + "media/1.c6f7d0aa.mp3";